import React, { useRef, useState } from "react";
import Alert from "react-bootstrap/Alert";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_URL from "./../../common/config";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Country } from "country-state-city";

const Result = () => (
  <Alert variant="success" className="success-msg">
    Your Inquiry has been successfully sent. Our team will be right back!
  </Alert>
);

const FormTwo = ({ onSuccess }) => {
  const form = useRef();
  const navigate = useNavigate();
  const countries = Country.getAllCountries();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    country: "",
    phone_no: "",
    message: "",
  });
  const [result, setResult] = useState(false);
  const [error, setError] = useState(null);

  const getCountryCode = () => {
    if (!formData.country) return undefined;
    return formData.country.toLowerCase();
  };

  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    const country = countries.find((c) => c.isoCode === countryCode);
    console.log("Country changed to:", countryCode);
    setFormData((prev) => ({
      ...prev,
      country: countryCode,
      phone_no: `+${country?.phonecode || ""}`,
    }));
  };

  const handlePhoneChange = (value) => {
    console.log("Phone number changed to:", value);
    setFormData((prev) => ({ ...prev, phone_no: value }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    console.log("Form data being sent:", formData);

    try {
      const response = await axios.post(
        `${API_URL}/api/contact/help-center`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201) {
        console.log("Form submitted successfully, email sent");
        setFormData({
          name: "",
          email: "",
          country: "",
          phone_no: "",
          message: "",
        });
        setResult(true);
        setTimeout(() => setResult(false), 5000);
      }
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.error("Submission error:", err.response?.data || err.message);
      setError(err.response?.data?.message || err.message);
    }
  };

  return (
    <form ref={form} onSubmit={handleSubmit} className="axil-contact-form">
      <div className="form-group">
        <label>Name</label>
        <input
          type="text"
          className="form-control"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label>Email</label>
        <input
          type="email"
          className="form-control"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label className="small-label">Tell us your country! *</label>
        <select
          name="country"
          value={formData.country || ""}
          onChange={handleCountryChange}
          className="form-control"
          required
        >
          <option value="" hidden>
            Select Country
          </option>
          {countries.map((country) => (
            <option key={country.isoCode} value={country.isoCode}>
              {country.name}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label className="small-label">Mobile No.*</label>
        <PhoneInput
          value={formData.phone_no || ""}
          name="phone_no"
          onChange={handlePhoneChange}
          className="form-control"
          required
          country={getCountryCode()}
          countryCallingCodeEditable={false}
          countrySelectProps={{
            disabled: false,
            className: "country-select-disabled",
          }}
        />
      </div>
      <div className="form-group mb--40">
        <label>How can we help you?</label>
        <textarea
          className="form-control"
          name="message"
          rows="4"
          value={formData.message}
          onChange={handleChange}
        ></textarea>
      </div>
      <div className="form-group">
        <button
          type="submit"
          className="axil-btn try-free-btn btn-fluid btn-primary"
        >
          Submit
        </button>
      </div>
      {result && <Result />}
      {error && <Alert variant="danger">{error}</Alert>}
      <style jsx>{`
        .country-select-disabled {
          pointer-events: none;
          opacity: 0;
        }
      `}</style>
    </form>
  );
};

export default FormTwo;
